<div class="form-group">

  <label [attr.for]="buildChildId()"
         [class.sr-only]="!label"
         [ngClass]="labelStyleModifier">
    {{label}}
  </label>

  <ng-select #ngSelect class="form-control project-select custom-select" required
             [ngClass]="{'has-selected': isSelectedItem() === true, 'error': hasError()}"
             [name]="name"
             [items]="options"
             [multiple]="multiple"
             [closeOnSelect]="!multiple"
             bindValue="id"
             bindLabel="name"
             [placeholder]="placeholder"
             [searchable]="false"
             [(ngModel)]="model"
             (open)="onOpenDopdown($event)"
             (close)="onBlur($event)"
             (change)="onSelectProject($event)"
             (mouseover)="onMouseOver()">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="d-flex flex-row project-selection-container"
           [ngClass]="{'new-project-line': item.id === 0}">
        <div class="project-name-wrapper d-flex flex-auto"
             [actionByLevels]="item.id === 0 ? 'Edit Project' : 'Standard Reports (Performance, Exposure, Segmentation, ROI)'"
             [wallName]="'Projects Disabled'"
             [actionData]="getProjectActionDataByContext(item.id === 0)"
             (afterChecking)="onClickProjectOption($event, item)">
          {{item.name}}
        </div>
        <div *ngIf="item.id > 0 && allowToModifyProject" class="d-flex flex-row align-items-center project-icons-container">
          <a class="setting-icon"
             actionByLevels="Edit Project"
             [wallName]="'Projects Disabled'"
             [actionData]="getProjectActionDataByContext(item.id === 0)"
             (afterChecking)="onEditProject(item)">
            <img src="assets/images/Light_Edit_Icon.svg" width="13" height="13">
          </a>
          <a class="delete-icon"
             actionByLevels="Edit Project"
             [wallName]="'Projects Disabled'"
             [actionData]="getProjectActionDataByContext(false, true)"
             (afterChecking)="onShowDeleteWarningPopup($event, item)">
            <img src="assets/images/Trash_Icon_White.svg" width="13" height="13">
          </a>
        </div>
      </div>
    </ng-template>
    <ng-template *ngIf="multiple" ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of (items ? items.slice(0,1): [])">
        {{placeholder}}
      </div>
    </ng-template>
  </ng-select>
</div>

<achoo-popup #deleteProjectWarning
             [isAlertPopup]="true"
             acceptBtnLabel="{{'project.delete_yes' | translate}}"
             cancelBtnLabel="{{'project.delete_no' | translate}}"
             (acceptCallback)="executeDeleteProject($event)"
             (cancelCallback)="hideDeletePopup()">
  <div>
    {{'measure.delete_project_message' | translate:{project_name: getDeleteProjectName()} }}
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/measure/project-selection/project-selection.component.html